import React from 'react';
import ReactDOM from 'react-dom/client';
import FontFaceObserver from 'fontfaceobserver';
import './styles/index.css';
import './styles/global.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));

const renderApp = () => {
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
};

const mulish = new FontFaceObserver('Mulish');
const fuzzyBubbles = new FontFaceObserver('Fuzzy Bubbles');

Promise.all([mulish.load(), fuzzyBubbles.load()])
  .then(() => {
    document.documentElement.classList.add('fonts-loaded');
    renderApp();
  })
  .catch((err) => {
    console.warn('Some critical font are not available:', err);
    renderApp(); // Render the app anyway
  });